import { Anchor } from '@zillow/constellation-10';

import type { ComponentProps } from 'react';

// CMS hero wrappers (e.g. `.jlvSHa a:not(StyledButton,StyledTextButton)`) force
// descendant links to white. Use HeroAnchor inside CMS-rendered
// zrm-marketing-components to preserve the Constellation link color.
const HeroAnchor = ({ css, ...rest }: ComponentProps<typeof Anchor>) => (
  <Anchor css={{ color: 'text.link.default !important', ...css }} {...rest} />
);

export default HeroAnchor;
